export default __webpack_public_path__ + "static/media/gesundheitpflegemono_dark.52a1f1aa.png";